import React from 'react';

import { BodyText, Button, Heading, Modal, PinAlertIllustration } from '@placer-ui/components';
import { TitleModalHeader } from 'features/offline-reports/support-requests/components/support-requests-modals/components/title-modal-header/title-modal-header';

import styles from './resolver-process-failed-modal.module.scss';
import { SupportRequestType } from 'features/offline-reports/support-requests/components/support-requests-modals/types';
import { useOpenSupportRequest } from 'features/offline-reports/support-requests/components/support-requests-modals/support-modal-manager';

export const ResolverProcessFailedModal = ({
    retryModalType,
}: {
    retryModalType: SupportRequestType;
}) => {
    const { openSupportRequest } = useOpenSupportRequest();
    return (
        <>
            <TitleModalHeader title="Ticket Submission Failed" />
            <Modal.Content>
                <div className={styles.failedContent}>
                    <div className={styles.failedIcon}>
                        <PinAlertIllustration />
                    </div>
                    <Heading variant="h2">
                        We Couldn't Verify the Coverage of Your Properties
                    </Heading>
                    <BodyText>Please retry, if the issue persists contact support.</BodyText>
                </div>
            </Modal.Content>
            <Modal.Footer>
                <Modal.Footer.RightControls>
                    <Button
                        testId="support-request-failed-modal-close"
                        variant="secondary-blue"
                        fullWidth
                        onClick={() => openSupportRequest({ flowType: 'askSupport' })}
                    >
                        Contact Support
                    </Button>
                    <Button
                        testId="support-request-failed-modal-retry"
                        variant="primary-brand"
                        fullWidth
                        onClick={() => openSupportRequest({ flowType: retryModalType })}
                    >
                        Retry
                    </Button>
                </Modal.Footer.RightControls>
            </Modal.Footer>
        </>
    );
};
